/* eslint-disable prettier/prettier */
const ContentSwitcher = () => {
    // Function to handle click on content-switch-trigger__choose
    const handleChooseClick = () => {
        const pageOverlay = document.querySelector('.content-switch-trigger__page-overlay');
        const contentTrigger = document.querySelector('.content-switch-trigger');

        // Toggle class for page overlay
        pageOverlay.classList.toggle('content-switch-trigger__page-overlay--active');

        // Toggle class for content switch trigger
        contentTrigger.classList.toggle('content-switch-trigger--active');
    };

    // Function to remove active classes
    const removeActiveClasses = () => {
        const pageOverlay = document.querySelector('.content-switch-trigger__page-overlay');
        const contentTrigger = document.querySelector('.content-switch-trigger');

        // Remove class for page overlay
        pageOverlay.classList.remove('content-switch-trigger__page-overlay--active');

        // Remove class for content switch trigger
        contentTrigger.classList.remove('content-switch-trigger--active');
    };

    // Function to handle the intersection of .footer
    const handleFooterIntersection = (entries, observer) => {
        entries.forEach(entry => {
            const chooseElement = document.querySelector('.content-switch-trigger__choose');
            if (chooseElement) {
                if (entry.isIntersecting) {
                    chooseElement.classList.add('content-switch-trigger__choose--hidden');
                } else {
                    chooseElement.classList.remove('content-switch-trigger__choose--hidden');
                }
            }
        });
    };

    // Attach click event listener to content-switch-trigger__choose
    document.addEventListener('DOMContentLoaded', () => {
        const chooseButton = document.querySelector('.content-switch-trigger__choose');
        if (chooseButton) {
            chooseButton.addEventListener('click', handleChooseClick);
        }

        // Attach click event listener to content-switch-trigger__close
        const closeButton = document.querySelector('.content-switch-trigger__close');
        if (closeButton) {
            closeButton.addEventListener('click', removeActiveClasses);
        }

        // Attach keydown event listener to document to handle escape key
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                removeActiveClasses();
            }
        });

        // Setup intersection observer for .footer
        const footer = document.querySelector('.footer');
        if (footer) {
            const observer = new IntersectionObserver(handleFooterIntersection, { threshold: 0 });
            observer.observe(footer);
        }
    });
};

export default ContentSwitcher;
